import { SET_META } from '../actions'

const metaReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_META:
      return { ...state, ...action.meta }
    default:
      return state
  }
}

export default metaReducer
